import { IVariant } from '../../types/PDP';

export const computeQuantityRemaining = (currentVariant: IVariant | undefined): number => {
  return currentVariant?.availableForSale && currentVariant?.quantityAvailable > 0
    ? currentVariant.quantityAvailable
    : -1;
};
